import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=fe432e50&scoped=true&"
import script from "./WordCloud.vue?vue&type=script&lang=ts&"
export * from "./WordCloud.vue?vue&type=script&lang=ts&"
import style0 from "./WordCloud.vue?vue&type=style&index=0&id=fe432e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe432e50",
  null
  
)

export default component.exports